import React, { useState } from 'react';
import { Form, Formik, Field } from 'formik';
import * as moment from 'moment';
import AlertModal from 'web/components/AlertModal';
import { getPostInitialValues, VALIDATION_SCHEMA, } from 'web/components/utils/recurranceModalUtils';
import Button from 'web/components/Button';
import CheckboxInput from 'web/components/form-elements/CheckboxInput';
import Select from 'web/components/form-elements/Select';
import DatePicker from 'web/components/form-elements/DatePicker';
import NumberInput from 'web/components/form-elements/NumberInput';
import RadioButton from 'web/components/form-elements/RadioButton';
import CloseIcon from 'web/assets/images/CloseIcon.png';
import styles from '../postLoad.module.scss';
import { Modal, ModalBody } from 'reactstrap';
import styled from 'styled-components'
import { Container, Body, RecurrencePattern, Heading, BoxWrapper, ModalContainer, PatternWrapper, RadioData, RadioWrapper } from './requestDateModalStyled'
import { getPatternArr, getMonthlyArr, getDaysArr, getCountDropDownArr, getDaysDropDownArr } from '../../constants'

export default ({ isOpen, toggle, title, selectedType, recurrenceType, onClickHander, recurrenceObjState, recurranceDateState, pageLanguageContents }) => {
  const [getClearDateFlag, setCearDateFlag] = useState(false)
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('/');
  const toggleModal = () => setModal(!modal);
  const [recurrenceState, setRecurrenceState] = useState('DAILY');

  let recurrenceArr = []
  if (title === 'Setup Recurring Post') {
    recurrenceArr = [{ value: 'endBy', label: pageLanguageContents?.RecurrenceModal[0]?.ByEndDate },]
  } else {
    if (selectedType === "DELIVERABLE") {
      recurrenceArr = [{ value: 'endBy', label: 'By Requested Delivery' }]
    } else {
      recurrenceArr = [{ value: 'endBy', label: 'By Requested Pickup' },]
    }
  }

  // fetching the required constants for the component
  const patternArr = getPatternArr(pageLanguageContents)
  const monthlyArr = getMonthlyArr(pageLanguageContents)
  const daysArr = getDaysArr(pageLanguageContents)
  const countDropDownArr = getCountDropDownArr(pageLanguageContents)
  const daysDropDownArr = getDaysDropDownArr(pageLanguageContents)

  const everyCall = (label, firstTitle, lastTitle, classNameSet) => {
    return <DailyWrapper >
      <div>
        <p className='m-0' >{firstTitle}</p>
      </div>
      <div>
        <NumberInput
          name={classNameSet}
          placeholder=''
          disabled={label === 'daily' ? true : false}
          showErrorMessages={true}
        />

        <p className='m-0' >{lastTitle}</p>
      </div>
    </DailyWrapper>
  }

  const dailyCall = (props) => {
    return <><div className="row mx-0">
      {everyCall(
        'daily', pageLanguageContents?.RecurrenceModal[28]?.Every,
        pageLanguageContents?.RecurrenceModal[29]?.Days,
        pageLanguageContents?.RecurrenceModal[30]?.Interval1
      )}
    </div>
    </>
  }
  const weeklyCall = (props) => {
    return <><div className=" mx-0">
      <div>
        {everyCall(
          'weekly', pageLanguageContents?.RecurrenceModal[31]?.RecEvery,
          pageLanguageContents?.RecurrenceModal[32]?.WeeksOn,
          pageLanguageContents?.RecurrenceModal[33]?.Interval2
        )}</div>
      <WeeklyDays>{daysArr &&
        daysArr.map((value, index) => (
          <div className={styles.field} key={index}>
            {title !== "Committed Order Recurrance" ? <CheckboxInput
              name={"dayOfWeek" + index}
              label={daysArr[index].label}
              handleSelect={(val, label, flag) => {
              }}
            /> :
              <Field
                component={RadioButton}
                name='dayOfWeek'
                id={value.value}
                defaultValue={daysArr[0].value}
                onSelect={(e) => {
                }}
                label={value.label}
              />}
          </div>
        ))}</WeeklyDays>
    </div>
    </>
  }

  const monthlyCall = (props) => {
    return <>
      <TheDaySection>
        <div>{monthlyArr &&
          monthlyArr.map((value, index) => (
            <div key={index}>
              <Field
                component={RadioButton}
                name='monthlyRadio'
                id={value.value}
                defaultValue={monthlyArr[0].value}
                onSelect={(e) => {
                }}
                label={value.label}
              />
            </div>
          ))}</div>
        <div>
          <NoDay>
            <div className='app-input-text'>
              <NumberInput
                name='noDay'
                placeholder=''
                showErrorMessages={true}
              />
            </div>

            {everyCall(
              'monthly', pageLanguageContents?.RecurrenceModal[36]?.OfEvery,
              pageLanguageContents?.RecurrenceModal[37]?.Months,
              pageLanguageContents?.RecurrenceModal[38]?.Interval3
            )}
          </NoDay>

          <TheDay>
            <Select
              name='index'
              data={countDropDownArr}
              placeholder='Count&#42;'
              searchable={false}
            />
            <Select
              name='daysdropDown'
              data={daysDropDownArr}
              placeholder='Days&#42;'
              searchable={false}
            />
            {everyCall(
              'monthly', pageLanguageContents?.RecurrenceModal[39]?.ofEvery2,
              pageLanguageContents?.RecurrenceModal[40]?.Months2,
              pageLanguageContents?.RecurrenceModal[41]?.TheEvery
            )}
          </TheDay>
        </div>
      </TheDaySection>
    </>
  }

  const stateObjCreate = (props, btnVal) => {
    let requestDeliveryDate = props.values.recurranceStartDate
    if (btnVal === 'no') {
      requestDeliveryDate = recurrenceObjState.requestDeliveryDate
    }
    let weeklyArr = [];
    if (props.values.dayOfWeek0) {
      weeklyArr.push(daysArr[0].value)
    } if (props.values.dayOfWeek1) {
      weeklyArr.push(daysArr[1].value)
    } if (props.values.dayOfWeek2) {
      weeklyArr.push(daysArr[2].value)
    } if (props.values.dayOfWeek3) {
      weeklyArr.push(daysArr[3].value)
    } if (props.values.dayOfWeek4) {
      weeklyArr.push(daysArr[4].value)
    } if (props.values.dayOfWeek5) {
      weeklyArr.push(daysArr[5].value)
    } if (props.values.dayOfWeek6) {
      weeklyArr.push(daysArr[6].value)
    } if (props.values.dayOfWeek7) {
      weeklyArr.push(daysArr[7].value)
    }

    let UPDATE_STATE = {
      yesNoBtns: btnVal,
      requestDeliveryDate: requestDeliveryDate,
      type: props.values.type,
      interval: props.values.interval,
      dayOfWeek: props.values.dayOfWeek,
      daysOfWeek: weeklyArr,
      dayOfMonth: props.values.theEvery,
      index: props.values.index,
      daysdropDown: props.values.daysdropDown,
      theDayRadio: props.values.monthlyRadio,
      recurrenceRadio: props.values.recurrenceRadio,
      noDay: props.values.noDay,
      start: props.values.recurranceStartDate,
      endBy: props.values.recurranceEndDate,
      endAfterOccurrences: props.values.endAfterOccurrences
    }
    onClickHander(UPDATE_STATE)
  }

  const recurrenceValidateFun = async (props, setFieldValue) => {
    let type = props.values.type
    if (type === '' || !type) {
      setModalContent("Please select the recurrence pattern.");
      setModalLink('');
      toggleModal();
    } else {
      let dayOfWeek = props.values.daysdropDown ? props.values.daysdropDown : null
      let dayOfMonth = props.values.dayOfMonth
      let index = props.values.index
      let interval = props.values.interval
      let weeklyArr = [];
      if (props.values.type === "DAILY") {
        dayOfWeek = null
        dayOfMonth = null
        index = null
      } else if (props.values.type === "WEEKLY") {
        dayOfMonth = null
        index = null
        if (props.values.dayOfWeek0) {
          weeklyArr.push(daysArr[0].value)
        } if (props.values.dayOfWeek1) {
          weeklyArr.push(daysArr[1].value)
        } if (props.values.dayOfWeek2) {
          weeklyArr.push(daysArr[2].value)
        } if (props.values.dayOfWeek3) {
          weeklyArr.push(daysArr[3].value)
        } if (props.values.dayOfWeek4) {
          weeklyArr.push(daysArr[4].value)
        } if (props.values.dayOfWeek5) {
          weeklyArr.push(daysArr[5].value)
        } if (props.values.dayOfWeek6) {
          weeklyArr.push(daysArr[6].value)
        } if (props.values.dayOfWeek7) {
          weeklyArr.push(daysArr[7].value)
        }
        if (weeklyArr.length === 0) {
          setModalContent("Please select days of week.");
          setModalLink('');
          toggleModal();
          return
        }
      } else {
        if (props.values.monthlyRadio === "Day") {
          dayOfWeek = null
          index = null
          dayOfMonth = props.values.noDay
        } else {
          if (props.values.monthlyRadio === '') {
            setModalContent("Please select the recurrence pattern type Day or The.");
            setModalLink('');
            toggleModal();
            return;
          } else {
            interval = null
            dayOfWeek = props.values.daysdropDown
            dayOfMonth = props.values.theEvery
            type = "RELATIVEMONTHLY"
          }
        }
      }
      stateObjCreate(props, 'yes')
      setFieldValue("index", 'FIRST');
      setFieldValue("daysdropDown", 'MONDAY');
      setFieldValue("monthlyRadio", 'Day');
      setFieldValue("type", '');
      setFieldValue("recurrenceRadio", 'endBy');
      setFieldValue("noDay", 1);
      setFieldValue("theEvery", 1);
      setFieldValue("endAfterOccurrences", 1);
      toggle(!isOpen)
    }
  }

  const dateSet = (props) => {
    return <div className='row'>
      <div className='col-md-4'>
        <p>{pageLanguageContents?.RecurrenceModal[2]?.StartDate}<span class="star">*</span></p>

        <DatePicker
          name="recurranceStartDate"
          type={title !== 'Setup Recurring Post' ? 'recOrderPost' : ''}
          placeholderText=""
          clearDateFlag={getClearDateFlag}
          selectedDate={props.values.recurranceStartDate}
          callBackFun={(date) => {
            setCearDateFlag(false)
          }}
        />
      </div>
      <div className='col-md-4'>
        <p>{pageLanguageContents?.RecurrenceModal[3]?.EndDate} <span class="star">*</span></p>
        <DatePicker
          name='recurranceEndDate'
          type={title !== 'Setup Recurring Post' ? 'recOrderPost' : ''}
          clearDateFlag={getClearDateFlag}
          selectedDate={props.values.recurranceEndDate}
          minDate={props.values.recurranceStartDate}
          callBackFun={(date) => {
            setCearDateFlag(false)
          }}
        />
      </div>
    </div>
  }

  return (
    <ModalContainer>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={'static'}
        centered={true}
        fullscreen='fullscreen'
        className={styles.recurranceModal}
      >
        <div className=''>
          <div className={styles.header}>
            <Button handleClick={() => {
              setRecurrenceState('DAILY')
              toggle(!isOpen)
              let UPDATE_STATE = {
                yesNoBtns: "no",
              }
              onClickHander(UPDATE_STATE)
            }}>
              <img src={CloseIcon} className="closeIcon" alt="close-icon" />
            </Button>
            <h3>{title}</h3>
            {title === 'Setup Recurring Order' ?
              <p style={{ padding: "0 20px", textAlign: 'center' }}>Fill out the following information to outline your daily, weekly, or monthly requirements. Users that bid on this post  will have to fulfill the post requirements and commit to the timeline that is requested.</p>
              : recurrenceType === "Inventory" ? <p style={{ padding: "0 20px", textAlign: 'center' }}>Fill out the following requirements to have your inventory posted on a daily, weekly, or monthly recurring schedule.</p> : <p style={{ padding: "0 20px", textAlign: 'center' }}>Fill out the following requirements to have your need posted on a daily, weekly, or monthly recurring schedule.</p>}

          </div>
          <ModalBody>
            <Formik
              initialValues={getPostInitialValues(recurrenceObjState)}
              validationSchema={VALIDATION_SCHEMA()}
              onSubmit={(values) => {
              }}>
              {(props) => {
                const { setFieldValue, } = props;
                return (
                  <>
                    <Form>
                      <Container>
                        <Body>
                          <EndRadioWrapper>
                            <div className='row'>
                              {recurrenceArr &&
                                recurrenceArr.map((value, index) => (
                                  <div className={styles.field} key={index}>
                                    <Field
                                      component={RadioButton}
                                      name='recurrenceRadio'
                                      id={value.value}
                                      defaultValue={recurrenceArr[0].value}
                                      onSelect={(e) => {
                                        setFieldValue("type", '');
                                        setCearDateFlag(true)
                                      }}
                                      label={value.label}
                                    />
                                  </div>
                                ))}
                            </div>
                          </EndRadioWrapper>
                          <div className='col-12'>
                            {dateSet(props)}
                          </div>
                          <RecurrencePattern>
                            <Heading>
                              {title === 'Setup Recurring Post' && <h6>{pageLanguageContents?.RecurrenceModal[5]?.RecPattern}<span class="star">*</span></h6>}
                              {title !== 'Setup Recurring Post' && <h6>Recurring Order<span class="star">*</span></h6>}
                            </Heading>

                            <BoxWrapper>
                              <PatternWrapper>
                                <RadioWrapper>
                                  {patternArr &&
                                    patternArr.map((value, index) => (
                                      <div key={index}>
                                        <Field
                                          component={RadioButton}
                                          name="type"
                                          id={value.value}
                                          defaultValue={patternArr[0].value}
                                          onSelect={(e) => {
                                            setRecurrenceState(e.target.value);
                                            setFieldValue("interval", 1);
                                            setFieldValue("noDay", 1);
                                            setFieldValue("theEvery", 1);
                                          }}
                                          label={value.label}
                                        />
                                      </div>
                                    ))}
                                </RadioWrapper>
                                <RadioData>
                                  {recurrenceState === "DAILY" &&
                                    dailyCall(props)}
                                  {recurrenceState === "WEEKLY" &&
                                    weeklyCall(props)}
                                  {recurrenceState === "MONTHLY" &&
                                    monthlyCall(props)}
                                </RadioData>
                              </PatternWrapper>
                            </BoxWrapper>
                          </RecurrencePattern>

                          <ActionBtn>
                            <Button
                              type="app-green-button submitBtn"
                              handleClick={() => {
                                toggle(!isOpen);
                                setRecurrenceState('DAILY')
                                stateObjCreate(props, "no");
                              }}
                            >
                              {pageLanguageContents?.RecurrenceModal[42]?.CancelButton}
                            </Button>
                            <Button
                              type="app-green-button"
                              handleClick={async () => {
                                recurrenceValidateFun(props, setFieldValue);
                              }}
                            >
                              {pageLanguageContents?.RecurrenceModal[43]?.SubmitButton}
                            </Button>
                            <Button
                              type="app-green-button widthSet"
                              handleClick={async () => {
                                setRecurrenceState('DAILY')
                                setFieldValue("dayOfWeek0", '');
                                setFieldValue("dayOfWeek1", '');
                                setFieldValue("dayOfWeek2", '');
                                setFieldValue("dayOfWeek3", '');
                                setFieldValue("dayOfWeek4", '');
                                setFieldValue("dayOfWeek5", '');
                                setFieldValue("dayOfWeek6", '');

                                setFieldValue("index", '');
                                setFieldValue("daysdropDown", '');
                                setFieldValue("monthlyRadio", '');
                                setFieldValue("type", '');
                                setFieldValue("recurrenceRadio", 'endBy');
                                setFieldValue("noDay", '');
                                setFieldValue("theEvery", '');
                                setFieldValue("endAfterOccurrences", '');
                                setCearDateFlag(true)

                                //reset the dates
                                let startDate = moment(new Date().setDate(new Date().getDate() + 4)).format('MM/DD/YYYY')
                                let getDate = new Date()
                                let nextMonth = getDate.setMonth(getDate.getMonth() + 1);
                                let endDate = moment(new Date(nextMonth).setDate(new Date(nextMonth).getDate() + 4)).format('MM/DD/YYYY')
                                setFieldValue("recurranceStartDate", startDate);
                                setFieldValue("recurranceEndDate", endDate);
                              }}
                            >
                              {pageLanguageContents?.RecurrenceModal[44]?.ClearButton}
                            </Button>
                          </ActionBtn>
                        </Body>
                      </Container>
                    </Form>
                  </>
                );
              }}
            </Formik>

          </ModalBody>
          <AlertModal
            isOpen={modal}
            toggle={toggleModal}
            title=''
            content={modalContent}
            link={modalLink}
          />
        </div>
      </Modal>
    </ModalContainer >
  );
};

const DailyWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
  .app-input-text input {

  }
  > div {
    display: flex;
    align-items: center;
    gap: 10px;

    .app-input-text {
      margin: 0;
      input {
        max-width: 54px;
        text-align: center;
        min-width: 54px;
      }
    }
  }
`;

const EndRadioWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
 
    > div{
      margin: 9px 0;
      >div {       
        margin-right: 10px;
      }
    }
     
`

const ActionBtn = styled.div`
 display: flex;
     margin: 15px 0;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 15px;
    > button {
      height: 38px;
    width: 90px;
    }
    .widthSet{
      width:auto;
    }
    @media (max-width:460px) {
      > button {
        :first-child,:nth-child(2) {
          width: calc(50% - 8px);
        }
        :nth-child(3) {
          width: 100%;
        }
      }
    }
`

const WeeklyDays = styled.div`    
    display: flex;
    flex-wrap: wrap;
    grid-column-gap: 15px;
    margin: 15px 0;
      > div {
        min-width: 100px;
        text-align: left;
      }
      @media (max-width:495px) {
        display: grid;
        grid-template-columns: 1fr 1fr;
      }
    `

const TheDaySection = styled.div`
  display: flex;
  > div {
    flex:1;
    :first-child {
      max-width: 100px;
      text-align: left;
      > div {
            margin-bottom: 15px;
            @media (max-width:455px) {
              margin-bottom: 70px;
            }
            @media (max-width:386px) {
              margin-bottom: 102px;
            }
      }
    }
  }
`
const NoDay = styled.div`
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
  flex-wrap: wrap;
      p {
        margin:0;
      }
  .app-input-text {
    margin: 0;
        flex: 1;
    max-width: 54px;
    min-width: 54px;
    input {
      text-align: center;
    }
  }

`

const TheDay = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  p {
    margin:0;
  }
  > div {
    flex:1;
    :first-child {
      max-width: 120px;
      min-width: 120px;
    }
    :nth-child(2) {
      max-width: 100px;
      min-width: 100px;
    }
    @media (max-width:419px) {
      :nth-child(2) {
      max-width: 120px;
      min-width: 120px;
    }
            }
  }

`